
import { createClient } from '@supabase/supabase-js'
import type { Database } from './types'

const supabaseUrl = "https://zbqpsxyzkblrgqmfepie.supabase.co"
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpicXBzeHl6a2JscmdxbWZlcGllIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDEzNzI0ODAsImV4cCI6MjA1Njk0ODQ4MH0.vMWGE3M3PHIfPa59D1KrErdTtXFSdRvp-OfiWbWS59k"

export const supabase = createClient<Database>(
  supabaseUrl,
  supabaseAnonKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      storage: typeof window !== 'undefined' ? window.localStorage : undefined,
      storageKey: 'supabase.auth.token',
      detectSessionInUrl: true,
      flowType: 'pkce'
    },
    global: {
      headers: {
        'X-Client-Info': 'supabase-js-web'
      }
    }
  }
)
